import React, { useState, useEffect } from 'react';

import useTable from '../useTable'
import axios from 'axios';
import { Dimmer } from '../spinner';

import { Mensaje } from '../mensajes';
import ModalImpresoras from './modalImpresoras';


const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCION', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'IP', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
]

function TablaImpresoras() {
    const op = require("../../../src/modulos/datos.js");


    const [mostrar, setMostrar] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [datos, setDatos] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })


    let token = sessionStorage.getItem('jwtToken');

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idimpresora.includes(target.value)
                            || x.descripcion.toUpperCase().includes(target.value.toUpperCase())
                            || x.ip.toUpperCase().includes(target.value.toUpperCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    useEffect(() => {
        seleccionarRegistros();
    }, []);


    const seleccionarRegistros = () => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'impresoras';
        let orden = 'idimpresora';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };



    const gestionarImpresoras = (item, ope) => (event) => {

        event.preventDefault();
        setOperacion(ope);
        if (ope === 1) {
            setMostrar(true);
        } else {
            setDatos(item);
            setMostrar(true);
        }

    };

    return (
        <div className='container-fluid rounded'>
            <div className='container-fluid'>
                <div className="card">
                    <Dimmer active={activate} />

                    <div className="container">
                        <div className="content" >
                            <div className="container">
                                <div className="col-md-12 row m-0 py-2">
                                    <div className="col-md-2">
                                        <input type="text" className="form-control form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" />
                                    </div>

                                    <div className="col-md-1 ml-auto">
                                        <button onClick={gestionarImpresoras('', 1)} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <TblContainer >
                                        <TblHead />

                                        <tbody>
                                            {

                                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                                    <tr key={index} style={{ padding: "0" }}>
                                                        <td className='align-baseline' style={{ textAlign: "center", width: "50px" }}>{item.idimpresora}</td>
                                                        <td className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{item.descripcion}</td>
                                                        <td className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{item.ip}</td>
                                                        <td className='align-baseline' style={{ textAlign: "center", width: "100px" }}>
                                                            <button onClick={gestionarImpresoras(item, 4)} className="btn btn-sm  btn-info rounded-circle ml-2" ><i className="fas fa-eye"></i> </button>
                                                            <button onClick={gestionarImpresoras(item, 2)} className="btn btn-sm  btn-warning rounded-circle ml-2"><i className="fa fa-edit"></i> </button>
                                                            <button onClick={gestionarImpresoras(item, 3)} className="btn btn-sm  btn-danger rounded-circle ml-2"><i className="fa fa-trash"></i> </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>

                                    </TblContainer>
                                    <TblPagination />

                                </div>
                            </div>
                        </div>
                    </div>
                    <Mensaje mensaje={mensaje}
                        onHide={() => {
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                        }
                        } />
                    <ModalImpresoras
                        show={mostrar}
                        operacion={operacion}
                        datos={datos}
                        onHideCancelar={() => { setMostrar(false), setDatos() }}
                        onHideAcepta={seleccionarRegistros}
                    />
                </div >
            </div>
        </div>
    );

}

export default TablaImpresoras;